import messageInformation from '@/services/general/messageInformation';
import { getPermissionForUser } from '@/api/utilisateur/index';
import { getAllPermissions } from '@/api/role/index';
import * as allTypes from '../mutation-type';
import * as types from './permissions-mutation-type';

function initialState() {
  return {
    permissions: {},
    allPermissions: [],
    userAffixe1: false,
    showPopup: false,
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_PERMISSION](state, permissions) {
    state.permissions = permissions;
  },
  [types.SET_ALL_PERMISSION](state, allPermissions) {
    state.allPermissions = allPermissions;
  },
  [types.PURGE_PERMISSION](state) {
    state.permissions = {};
    state.showPopup = false;
  },
  [types.SET_POPUP](state, bool) {
    state.showPopup = bool;
  },
  [types.SET_USER_AFFIXE1](state, bool) {
    state.userAffixe1 = bool;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadPermissions({ commit }) {
    const permissions = (await getPermissionForUser()).data.result;
    commit(types.SET_PERMISSION, permissions);
    if (process.env.NODE_ENV === 'development') {
      const allPermissions = (await getAllPermissions()).data.result.items;
      const allPermissionsSimple = allPermissions.map(x => x.name);
      commit(types.SET_ALL_PERMISSION, allPermissionsSimple);
    }
  },
  setPermissions({ commit }, payload) {
    commit(types.SET_PERMISSION, payload);
  },
  logOut: ({ commit }) => {
    commit(types.PURGE_PERMISSION);
  },
  showPopup: ({ commit }) => {
    commit(types.SET_POPUP, true);
  },
  hidePopup: ({ commit }) => {
    commit(types.SET_POPUP, false);
  },
};

const getters = {
  popup: state => {
    return state.showPopup;
  },
  userAffixe1: state => {
    return state.userAffixe1;
  },
  checkPermissions: state => payload => {
    const permission = `${payload.module}.${payload.element}.${payload.rule}`;
    if (process.env.NODE_ENV === 'development') {
      // le test de la longueur de allPermissions
      // est pour éviter une erreur si on purge toute les permissions
      if (state.allPermissions.length > 0 && !state.allPermissions.includes(permission)) {
        messageInformation(`Permission ${permission} inexistante dans le back`, 'is-danger');
      }
    }
    if (state.userAffixe1) {
      return true;
    }
    try {
      return state.permissions.includes(permission);
    } catch {
      return false;
    }
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
